
const checkRequired = (data) => {
    return !!data;
}

const checkLessThanStringLengh = (data, num) => {
    return !!data && typeof data === 'string' && data.length <= num;
}

const checkMatchStringLengh = (data, numAray) => {
    return !!data && typeof data === 'string' && numAray.includes(data.length.toString())
}

const checkYYYYMMDDDateFormat = (data) => {
    const datePattern = /^(19|20)\d{2}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[0-1])$/;
    return datePattern.test(data);
}

const checkEmail = (data) => {
    const email = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    return data && email.test(data);
}

const checkYN = (data) => {
   return data === 'Y' || data === 'N';
}

const deleteString = (data) => {
    return data?.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
}

const deleteHyphen = (data) => {
    return data?.replace(/-/gi, '');
}

const deleteSpecialCharacters = (data) => {
    const regExp = /\w|\s|[ㄱ-ㅎㅏ-ㅣ가-힣]/gi;

    if(!!data){
        const strData = data.match(regExp);
        return strData.join('');
    } else {
        return data;
    }
}

const deleteBlankSpace = (data) => {
    return data?.replace(/ /gi, '');
}

const dataTrim = (data) => {
    return data?.toString().trim();
}

const changePaymentMethod = (data) => {
    switch (data) {
        case '은행':
            return 'B';
        case '카드':
            return 'C';
        case 'CMS결제':
            return 'B';
        case '카드결제':
            return 'C';
        default:
            return null;
    }
}

const bizTypeCheck= (data) => {
    if(data === '사업자' || data === '개인'){
        return true
    }else return false
}

const cmsPayTypeCheck= (data) => {
    if(data === '카드' || data === '은행'){
        return true
    }else return false
}

const taxRequestTypeCheck= (data) => {
    if(data === '청구' || data === '영수'){
        return true
    }else return false
}

const changeCashReptType= (data) => {
    switch (data) {
        case '발행':
            return 'Y';
        case '대상':
            return 'Y';
        case '미발행':
            return 'N';
        default:
            return 'N';
    }
}

const changeBankCode = (data) => {
    const banks = {
        '산업은행': '002',
        '산업': '002',
        '기업은행': '003',
        '기업': '003',
        '국민은행': '004',
        '국민': '004',
        '수협' : '007',
        '농협' : '011',
        '농협은행' : '011',
        '우리은행' : '020',
        '우리' : '020',
        '제일은행' : '023',
        '제일' : '023',
        '씨티은행' : '027',
        '씨티' : '027',
        '대구은행' : '031',
        '대구' : '031',
        '부산은행' : '032',
        '부산' : '032',
        '광주은행' : '034',
        '광주' : '034',
        '제주은행' : '035',
        '제주' : '035',
        '전북은행' : '037',
        '전북' : '037',
        '경남은행' : '039',
        '경남' : '039',
        '새마을금고' : '045',
        '새마을' : '045',
        '신협' : '048',
        '우체국' : '071',
        '하나은행' : '081',
        '하나' : '081',
        '신한은행' : '088',
        '신한' : '088',
        '케이뱅크' : '089',
        '카카오뱅크' : '090',
        '유안타증권' : '209',
        '삼성증권' : '240'
    }

    return banks[data];
}


const func = {
    checkRequired,
    checkLessThanStringLengh,
    checkMatchStringLengh,
    checkYYYYMMDDDateFormat,
    deleteString,
    deleteHyphen,
    deleteSpecialCharacters,
    deleteBlankSpace,
    dataTrim,
    changePaymentMethod,
    changeBankCode,
    checkEmail,
    checkYN,
    bizTypeCheck,
    cmsPayTypeCheck,
    taxRequestTypeCheck,
    changeCashReptType
}


export default func;